import { fetchCotationsByPage, fetchCotationsByPageOrderBy, fetchCotationsById, fetchCotationsSellersFilters } from "../../api/cotation";
import {
    getInstalationsDropdown
} from "../../api/authentication";
import i18n from "../../i18n";
import { daysV2, monthsV2, yearsV2 } from "@/utils/simulation/staticDropdownValues";
import { FUEL } from "@/enums/fuel"
import {getProductsByFinancialId} from "@/api/simulation";
import { useFinancialNationality, loadFinancialNationalityMap } from "@/enums/financials/financialNationality";

import store from "@/store";

const mapVehicleToSimulationPage = (commit, response) => {
    const fuel = response.CAR_FUEL?.length === 1 ? FUEL[response.CAR_FUEL] : response.CAR_FUEL;
    commit("SimulationModule/setVehicleInfoField", { field: 'fuel', value: fuel }, { root: true });
    commit("SimulationModule/setVehicleInfoField", { field: 'grossWeight', value: response.CAR_GROSSWEIGHT }, { root: true });
    commit("SimulationModule/setVehicleInfoField", { field: 'euroTaxCode', value: response.CAR_TYLACODE }, { root: true });
    commit("SimulationModule/setVehicleInfoField", { field: 'enginePower', value: response.CAR_HP }, { root: true });
    commit("SimulationModule/setVehicleInfoField", { field: 'displacementEngine', value: response.CAR_DISPLACEMENT }, { root: true });
    commit("SimulationModule/setVehicleInfoField", { field: 'doors', value: response.CAR_NRDOORS }, { root: true });
    commit("SimulationModule/setVehicleInfoField", { field: 'places', value: response.CAR_SEATS }, { root: true });

    commit("SimulationModule/setVehicleInfoField", {
        field: 'vehicleCondition', value: response.CAR_TYPE === "Novo" ? { id: 1, value: i18n.t('pages.SimulatorPage.vehicleInfo.vehicleCondition.new') }
            : { id: 2, value: i18n.t('pages.SimulatorPage.vehicleInfo.vehicleCondition.old') }
    }, { root: true });

    if (response.CAR_TYPE === "Usado") {
        let carPlateDate = response?.CAR_DTPLATE;
        let carPlateDay = -1;
        if (carPlateDate) {
            if (carPlateDate?.endsWith("Z")) {
                carPlateDate = carPlateDate.slice(0, -1); // remove the last character ("Z")
            }
            carPlateDay = new Date(carPlateDate).getDate();
        }
        
        commit("SimulationModule/setVehicleInfoField", { field: 'plateDay', value: daysV2.find((item) => item.text === carPlateDay.toString()) }, { root: true });
        commit("SimulationModule/setVehicleInfoField", { field: 'plateMonth', value: monthsV2.find((item) => item.text === (response.CAR_MONTH).toString()) }, { root: true });
        commit("SimulationModule/setVehicleInfoField", {
            field: 'plateYear',
            value: yearsV2.find((item) => item.text === (response.CAR_YEAR).toString())
        }, { root: true });
    } else {
        commit("SimulationModule/setVehicleInfoField", { field: 'plateDay', value: { value: -1, text: "" } }, { root: true });
        commit("SimulationModule/setVehicleInfoField", { field: 'plateMonth', value: { value: -1, text: "" } }, { root: true });
        commit("SimulationModule/setVehicleInfoField", {
            field: 'plateYear',
            value: { value: -1, text: "" }
        }, { root: true });
    }

    commit("VehicleModule/setVehicleSelectByKey", { key: "vehicleCategory", value: response.CAR_CATEGORY }, { root: true });
    commit("VehicleModule/setVehicleSelectByKey", { key: "vehicleBrand", value: response.CAR_BRAND }, { root: true });
    commit("VehicleModule/setVehicleSelectByKey", { key: "vehicleModel", value: response.CAR_MODEL }, { root: true });
    commit("VehicleModule/setVehicleSelectByKey", { key: "vehicleVersion", value: response.CAR_VERSION }, { root: true });
    commit("VehicleModule/setFromCotation", true, { root: true });
}

const mapClientToSimulationPage = (commit, response) => {
    let birthdate = response?.CUSTOMERBIRTHDATE;
    if (birthdate?.endsWith("Z")) {
        birthdate = birthdate.slice(0, -1); // remove the last character ("Z")
    }

    commit("SimulationModule/setClientInfoField", { field: 'firstName', value: response.CUSTOMER_FIRST_NAME }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'firstSurname', value: response.CUSTOMER_FIRST_SURNAME }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'secondSurname', value: response.CUSTOMER_SECOND_SURNAME }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'birthdate', value: birthdate }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'phoneNumber', value: response.CUSTOMERPHONE }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'email', value: response.CUSTOMEREMAIL }, { root: true });
    
    commit("SimulationModule/setClientInfoField", { field: 'notes', value: response.CUSTOMEROBS }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'isENICompany', value: response.ISENICOMPANY }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'clientTypeLabel', value: response.CUSTOMERTYPE }, { root: true });
    
    commit("SimulationModule/setSellerInfoField", { field: 'seller', value: response.SALESMAN }, { root: true });
    //commit("SimulationModule/setClientInfoField", { field: 'seller', value: response.SALESMAN }, { root: true });
    //commit("SimulationModule/setSellerInfoField", { field: 'emailSeller', value: response.SALESMAN }, { root: true });

    state.clientType = response.CUSTOMERTYPE;
    state.isENICompany = response.ISENICOMPANY;
}

const mapClientToSimulationPageFromProposal = (commit, response) => {
    let birthdate = response?.CUSTOMERBIRTHDATE;
    if (birthdate?.endsWith("Z")) {
        birthdate = birthdate.slice(0, -1); // remove the last character ("Z")
    }

    commit("SimulationModule/setClientInfoField", { field: 'firstName', value: response.CUSTOMERFIRSTNAME }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'firstSurname', value: response.CUSTOMERFIRSTSURNAME }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'secondSurname', value: response.CUSTOMERSECONDSURNAME }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'birthdate', value: birthdate }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'phoneNumber', value: response.CUSTOMERPHONE }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'email', value: response.CUSTOMEREMAIL }, { root: true });
    
    commit("SimulationModule/setClientInfoField", { field: 'notes', value: response.CUSTOMEROBS }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'isENICompany', value: response.ISENICOMPANY }, { root: true });
    commit("SimulationModule/setClientInfoField", { field: 'clientTypeLabel', value: response.CUSTOMERTYPE }, { root: true });

    commit("SimulationModule/setSellerInfoField", { field: 'seller', value: response.SALESMAN }, { root: true });
    //commit("SimulationModule/setClientInfoField", { field: 'seller', value: response.SALESMAN }, { root: true });

    //Disable ClientInfo input section
    commit("SimulationModule/setIsClientInfoDisable", true, { root: true });
    commit("SimulationModule/setIsSellerInfoDisable", false, { root: true });
    
    const idFinancial = response?.ID_FINANCIAL;
    const isSpanishFinancial = useFinancialNationality("ES")?.includes(idFinancial) || false;
    commit("SimulationModule/setIsBBVASpain", isSpanishFinancial, { root: true });
    commit("SimulationModule/setPhoneNumberPrefix", isSpanishFinancial ? '+34' : '+351', { root: true });

    state.clientType = response.CUSTOMERTYPE;
    state.isENICompany = response.ISENICOMPANY;
}

const mapResultsSimulationPage = (commit, response) => {
    commit("SimulationModule/setSimulationResultsField", { field: 'initialEntry', value: response.INITIALENTRANCE }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'capitalToFinance', value: response.CAPITALTOFINANCE }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'feeWithoutInsurence', value: response.FEEWITHOUTINSURENCE }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'initialExpenses', value: response.EXPENSES }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'taxStamp', value: response.TAXSTAMP }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'portsExpenses', value: response.PORTSEXPENSES }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'taeg', value: response.TAEG }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'singlePPCValue', value: response.INSURANCE_PPCVALUE }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'firstPayment', value: response.FIRSTPAYMENT }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'period', value: response.PERIOD }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'fee', value: response.FEEWITHOUTINSURENCE }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'cleanRewardFinancial', value: 0 }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'cleanRewardInitialExpenses', value: 0 }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'cleanPPCRewardTotalValue', value: 0 }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'initialExpensesMinimun', value: "N/D" }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'residualValueMaximum', value: "N/D" }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'euribor', value: "N/D" }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'spread', value: "N/D" }, { root: true });

    const idSelFinancial = Number(response.ID_FINANCIAL);
    const isSpanishFinancial = useFinancialNationality("ES")?.includes(idSelFinancial) || false;
    
    switch (idSelFinancial) {
        case 12:
            commit("SimulationModule/setIsBBVAResults", true, { root: true });
            break;
        case 13:
            commit("SimulationModule/setIsBBVAResults", true, { root: true });
            break;
        case 15:
        case 16:
        case 17:
        case 18:
            commit("SimulationModule/setIsBBVAResults", true, { root: true });
            break;
        default:
            commit("SimulationModule/setIsBBVAResults", isSpanishFinancial, { root: true });
    }
}

const mapFinancialToSimulationPage = (commit, response) => {
    // Alterado para refletir apenas Mensal, temporariamente
    //commit("SimulationModule/setFinancingInfoField", { field: 'periodicity', value: response.PERIODICITY === "Mensal" ? { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.periodocity.monthly') } : { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.periodocity.trimestral') } }, { root: true });
    commit("SimulationModule/setFinancingInfoField", { field: 'periodicity', value: { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.periodocity.monthly') } }, { root: true });
    commit("SimulationModule/setFinancingInfoField", { field: 'interestRate', value: response.RATETYPE === "Fixa" ? { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.taxInfo.fixed') } : { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.taxInfo.indexed') } }, { root: true });
    commit("SimulationModule/setFinancingInfoField", { field: 'pvp', value: response.PRICE }, { root: true });
    
    commit("SimulationModule/setFinancingInfoEntry", { field: 'initialEntry', value: response.INITIALENTRANCE, hasChange: false }, { root: true });
    commit("SimulationModule/setFinancingInfoField", { field: 'rate', value: response.RATE }, { root: true });
    commit("SimulationModule/setFinancingInfoField", { field: 'period', value: response.PERIOD }, { root: true });
    // commit("SimulationModule/setFinancingInfoField", { field: 'legalTax', value: response.LEGAL_TAX }, { root: true });
    commit("SimulationModule/setFinancingInfoExpenses", { field: 'residualValue', value: response.RESIDUALVALUE }, { root: true });
    commit("SimulationModule/setSimulationResultsField", { field: 'guarantee', value: response.GUARANTEE }, { root: true });
    commit("SimulationModule/setFinancingInfoField", { field: 'withBail', value: response.WITH_CAUTION === "S" ? { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.bail.yes') } : { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.bail.no') } }, { root: true });
    commit("SimulationModule/setFinancingInfoField", { field: 'withFinancedExpenses', value: response.EXPENSES_FINANCE === "S" ? { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedExpenses.yes') } : { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedExpenses.no') } }, { root: true });
    commit("SimulationModule/setFinancingInfoField", { field: 'withFinancedTax', value: response.TAXSTAMP_FINANCE === "S" ? { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedTax.yes') } : { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedTax.no') } }, { root: true });
    
    commit("SimulationModule/setFinancingInfoField", { field: 'legalTax', value: response.LEGAL_TAX }, { root: true });
    commit("SimulationModule/setFinancingInfoField", { field: 'legalTaxInvoicedTo', value: response.LEGAL_TAX_INVOICED_TO }, { root: true });

    
    commit("SimulationModule/setIdCotation", response.ID, { root: true });

    state.activeFin = response.ID_FINANCIAL;
    state.activeProd = response.ID_PRODUCT;
    state.modality = response.INSURANCE_PPCNAME;
    state.modalityNr = response.INSURANCE_PPCNRINSUREDPEOPLE;

    state.legalTaxInvoicedTo = response.LEGAL_TAX_INVOICED_TO;
    
    // state.expenses = response.EXPENSES;
    state.withBail = response.WITH_CAUTION === "S" ? { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.bail.yes') } : { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.bail.no') };
    state.withFinancedExpenses = response.EXPENSES_FINANCE === "S" ? { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedExpenses.yes') } : { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedExpenses.no') };
    state.withFinancedTax = response.TAXSTAMP_FINANCE === "S" ? { id: 1, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedTax.yes') } : { id: 2, value: i18n.t('pages.SimulatorPage.financingInfo.withFinancedTax.no') };
    state.rate = response.RATE;
    state.period = response.PERIOD;
    state.idCotation = response.ID;
    state.activeProductsWithExpenses.forEach((productDetails) => {
        //console.log(productDetails)
        if (productDetails.value === response.ID_PRODUCT) {
            if (productDetails.expenses.length !== 0){
                productDetails.expenses.map((expense) => {
                    //console.log(expense)

                    if (response.CAR_TYPE === expense.CAR_TYPE) {
                        //console.log(expense)
                        state.expenses = expense.VALUE;
                    }
                    
                });
            } else {
                state.expenses = response.EXPENSES;
            }

            if (response.CAR_TYPE === 'Usado'){
                commit("SimulationModule/setFinancingInfoField", { field: 'legalTax', value: productDetails.legalExpenses }, { root: true });
            } else {
                commit("SimulationModule/setFinancingInfoField", { field: 'legalTax', value: response.LEGAL_TAX }, { root: true });
            }

            commit("SimulationModule/setFinancingInfoField", { field: 'legalTaxInvoicedTo', value: response.LEGAL_TAX_INVOICED_TO || "" }, { root: true });
        }
        
    });
};

const preSelectEntityOnNavbar = (commit, response) => {
    localStorage.setItem("instalationId", response.ID_SUPPLIERENTITY);
    commit("AuthenticationModule/setUserEntityId", response.ID_SUPPLIERENTITY, { root: true });
};

const getDefaultState = () => {
    return {
        cotationPageKey: 1,
        cotations: [],
        entities: [{
            value: -1,
            text: i18n.t('dropdownSelection'),
            disabled: true,
        }],
        entitiesMap: {},
        clientsFilters: [
            {
                value: -1,
                text: i18n.t('dropdownSelection'),
                disabled: true,
            },
            {
                value: 1,
                text: i18n.t("pages.SimulatorPage.clientInfo.clientType.individual"),
            },
            {
                value: 3,
                text: i18n.t("pages.SimulatorPage.clientInfo.clientType.company"),
                isENICompany: false,
            },
            {
                value: 20,
                text: i18n.t("pages.SimulatorPage.clientInfo.clientType.eniIndividual"),
                isENICompany: false,
            },
            {
                value: 21,
                text: i18n.t("pages.SimulatorPage.clientInfo.clientType.enicOMPANY"),
                isENICompany: true,
            },
            {
                value: 4,
                text: i18n.t("pages.SimulatorPage.clientInfo.clientType.autonomous"),
            }
        ],
        cotationFilters: {
            entity: "",
            clientType: "",
            clientName: "",
            dateFrom: "",
            dateTo: "",
            seller: "",
            idCotation: "",
            isENICompany: false,
        },
        totalPages: 0,
        totalResults: 0,
        activeFin: 0,
        activeProd: 0,
        modality: "",
        modalityNr: 0,
        expenses: 0,
        withBail: "",
        withFinancedExpenses: "",
        withFinancedTax: "",
        clientType: "",
        clientTypeText: "",
        isENICompany: false,
        rate: 0,
        period: -1,
        sellersFilters: [],
        sellersFiltersCount: 0,
        fromProposal: false,
        fromProposalData: {},
        legalTax: 0,
        legalTaxInvoicedTo: "",
        idCotation: -1,
        activeProductsWithExpenses: [],
    }
};
const state = getDefaultState();

const getters = {
    getCotationsByPage: (state) => state.cotations,
    getCotationTable(state) {
        const cotationsRaw = state.cotations;
        var cotationRowTable = [];

        const mapEntities = state.entitiesMap;

        cotationRowTable = cotationsRaw?.map((item) => {
            return {
                register: item?.ID,
                date: item?.DT_CREATED,
                client: item?.CUSTOMERNAME || '',
                financial: item?.PRODUCTNAME,
                fin: item?.ID_FINANCIAL,
                product: item?.CAR_VERSION,
                capital: item?.CAPITALTOFINANCE,
                createdByUserId: item?.ID_BUSINESSMANAGER,
                salesman: item.SALESMAN || '',
                pointOfSale: mapEntities.get(item.ID_SUPPLIERENTITY) || ''
            }
        }) || [];

        return cotationRowTable;
    },
    getEntities: (state) => state.entities,
    getMapEntities: (state) => state.entitiesMap,
    getClientFilters: (state) => state.clientsFilters,
    getCotationFilterByKey: (state) => key => state.cotationFilters[key],
    getCotationFilledFilters: (state) => Object.fromEntries(Object.entries(state.cotationFilters).filter(([, v]) => { return v != ""; })),
    getCotationTotalPages: (state) => state.totalPages,
    getCotationTotalResults: (state) => state.totalResults,
    getCotationStateByKey: (state) => key => state[key],
    getCotationPageKey: (state) => state.cotationPageKey,
    getSellersFilters: (state) => state.sellersFilters,
    isSellersFiltersDisabled: (state) => state.sellersFiltersCount === 0,
    getFromProposal: (state) => state.fromProposal,
    getFromProposalData: (state) => state.fromProposalData,
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    setCotationPageKey(state) {
        state.cotationPageKey += 1;
    },
    setCotationByPage(state, cotations) {
        state.cotations = cotations;
    },
    setEntities(state, entities) {
        var entitiesNeoObj = entities.map((item) => {
            return {
                value: item?.ID,
                text: item?.NAME
            };
        });

        entitiesNeoObj = [{
            value: -1,
            text: i18n.t('dropdownSelection'),
            disabled: true,
        }, ...entitiesNeoObj];

        state.entities = entitiesNeoObj;
    },
    setMapEntities(state, entities) {
        const map = new Map(entities.map((obj) => [obj.ID, obj.NAME]));
        state.entitiesMap = map;
    },
    setCotationFilterByKey(state, filter) {
        state.cotationFilters[filter.key] = filter.value
    },
    setCotationTotalPages(state, totalPages) {
        state.totalPages = totalPages;
    },
    setCotationTotalResults(state, totalResults) {
        state.totalResults = totalResults;
    },
    setCotationFilters(state, filters) {
        state.cotationFilters = filters;
    },
    setSellersFiltersCount(state, sellersFiltersCount) {
        state.sellersFiltersCount = sellersFiltersCount;
    },
    setSellersFilters(state, sellersFilters) {
        var sellersFiltersNeo = sellersFilters.map((item) => {
            return {
                value: item?.ID,
                text: item?.NAME
            };
        });

        sellersFiltersNeo = [{
            value: -1,
            text: i18n.t('dropdownSelection'),
            disabled: true,
        }, ...sellersFiltersNeo];

        state.sellersFilters = sellersFiltersNeo;
    },
    setCotationStateByKey(state, stateValue) {
        state[stateValue.key] = stateValue.value
    },
    setFromProposal(state, fromProposal) {
        state.fromProposal = fromProposal;
    },
    setFromProposalData(state, fromProposalData) {
        state.fromProposalData = fromProposalData;
    },
    setActiveProductsDropdownV2(state, activeProducts) {
        var newArrayOfObjDropdown = activeProducts.map(
            ({ ID: value, NAME: text, EXPENSES: expenses, EXPENSES_LEGALIZATION: legalExpenses, TAXSTAMP_FINANCE: taxStampFinance, EXPENSES_FINANCE: expensesFinance }) => ({
                value,
                text,
                expenses,
                legalExpenses,
                expensesFinance,
                taxStampFinance
            })
        );
        state.activeProductsWithExpenses = newArrayOfObjDropdown;
    },
};

const actions = {
    resetCotationState({ commit }) {
        commit('resetState');
    },
    async getCotationByPage({ commit }, page) {

        try {
            const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
            const idEntity = (page?.entityId && page?.entityId != 'undefined') ? page?.entityId : -1;
            
            const response = await fetchCotationsByPage(page?.page, page?.pageSize, idEntity || -1, idInstance);
            commit("setCotationByPage", response?.data?.data);
            commit("setCotationTotalPages", response?.data?.pages);
            commit("setCotationTotalResults", response?.data?.total);
        } catch (error) {
            console.log(error)
        }

    },
    async getCotationByPageOrderBy({ commit }, page) {

        try {
            const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
            const idEntity = (page?.entityId && page?.entityId != 'undefined') ? page?.entityId : -1;
            
            const response = await fetchCotationsByPageOrderBy(page.page, page.orderBy, page?.search, page?.pageSize, idEntity, idInstance);
            commit("setCotationByPage", response?.data?.data);
            commit("setCotationTotalPages", response?.data?.pages);
            commit("setCotationTotalResults", response?.data?.total);
        } catch (error) {
            console.log(error)
        }

    },
    async getCotationById({ commit }, id) {

        try {
            const response = await fetchCotationsById(id);
            const idFinancial = response?.data?.data.ID_FINANCIAL;
            const products = await getProductsByFinancialId(response?.data?.data.ID_FINANCIAL, response?.data?.data.ID_SUPPLIERENTITY);

            loadFinancialNationalityMap();

            commit("setActiveProductsDropdownV2", products?.data?.data);

            const isSpanishFinancial = useFinancialNationality("ES")?.includes(idFinancial) || false;
            commit("SimulationModule/setIsBBVASpain", isSpanishFinancial, { root: true });
            commit("SimulationModule/setPhoneNumberPrefix", isSpanishFinancial ? '+34' : '+351', { root: true });
           
            commit("SimulationModule/setIdCotation", response?.data?.data?.ID, { root: true });
            commit("SimulationModule/setCotationData", response?.data?.data, { root: true });

            // commit("SimulationModule/setHasSimulation", true, { root: true });
            mapVehicleToSimulationPage(commit, response?.data?.data);
            mapClientToSimulationPage(commit, response?.data?.data);
            mapResultsSimulationPage(commit, response?.data?.data);
            mapFinancialToSimulationPage(commit, response?.data?.data);
            preSelectEntityOnNavbar(commit, response?.data?.data);

        } catch (error) {
            console.log(error)
        }

    },
    async getSellersDropdown({ commit }) {

        try {
            const response = await fetchCotationsSellersFilters();
            commit("setSellersFilters", response?.data?.data);
            commit("setSellersFiltersCount", response?.data?.count);
        } catch (error) {
            console.log(error)
        }

    },
    async fetchInstalationsDropdown({ commit }) {

        try {
            const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getInstalationsDropdown(idInstance);
            const entities = response?.data?.data || [];
            commit("setEntities", entities);
            commit("setMapEntities", entities);

        } catch (error) {
            console.log(error)
        }

    },
    resetClientTypeFilter({ commit }) {
        commit("setCotationStateByKey", {
            key: "clientsFilters",
            value: [
                {
                    value: -1,
                    text: i18n.t('dropdownSelection'),
                    disabled: true,
                },
                {
                    value: 1,
                    text: "Particular",
                },
                {
                    value: 3,
                    text: "Empresa",
                },
                {
                    value: 2,
                    text: "ENI",
                },
            ]
        });
    },
    /* eslint-disable */
    //Reutilizar os métodos de autopreenchemento da cotação > simulação
    async reuseCotationMethods({ commit, rootGetters }, { formData, finId, gscCode, proposalId, clientType, isENICompany, idCotation, legalTaxInvoicedTo}) {   
        const keysToFind = ["carType", "carCategory", "carBrand",
            "carModel", "carVersion", "carDisplacement", "carHp", "carGrossweight",
            "carFuelType", "carSeats", "carNrDoors", "carTylacode", "carKms", "firstName",
            "firstSurname", "secondSurname",
            "birthdateText", "phone1", "salesman", "email", "productName",
            "periodicity", "rateClient", "rateType", "initialEntrance",
            "period", "idBusinessManager", "canvasserIdEntity", "taeg",
            "residualValue", "guarantee", "lackPeriod", "maintenanceContract",
            "expensesClient", "expensesFinance", "purchaseIVA", "salesIVA",
            "taxStamp", "taxstampFinance", "portsExpenses",
            "price", "idProduct", "carMonth", "carYear", "carDtplate",
            "feeWithoutInsurenceClient", "capitalToFinance", "insurancePPCName",
            "insurancePPCNrInsuredPeople", "name", "comcaucao"];
        const foundKeys = {};
        const expensesClient = rootGetters["ProposalsModule/getExpensesClient"];

        // Descobrir os values do form consoante a key
        keysToFind.forEach((key) => {
            formData.tabs.forEach((tab) => {
                tab.form.forEach((form) => {
                    form.fields.forEach((field) => {
                        if (field.key === key) {
                            foundKeys[key] = field.value;
                        }
                    });
                });
            });
        });

        const formDataPayload = {
            // Vehicle data
            "CAR_BRAND": foundKeys["carBrand"],
            "CAR_CATEGORY": foundKeys["carCategory"],
            "CAR_DISPLACEMENT": foundKeys["carDisplacement"],
            "CAR_FUEL": foundKeys["carFuelType"],
            "CAR_GROSSWEIGHT": foundKeys["carGrossweight"],
            "CAR_HP": foundKeys["carHp"],
            "CAR_KMS": foundKeys["carKms"],
            "CAR_MODEL": foundKeys["carModel"],
            "CAR_MONTH": foundKeys["carMonth"],
            "CAR_NRDOORS": foundKeys["carNrDoors"],
            "CAR_PLATE": "",
            "CAR_DTPLATE": foundKeys["carDtplate"],
            "CAR_SEATS": foundKeys["carSeats"],
            "CAR_TYLACODE": foundKeys["carTylacode"],
            "CAR_TYPE": foundKeys["carType"],
            "CAR_VERSION": foundKeys["carVersion"],
            "CAR_YEAR": foundKeys["carYear"],
            "CREATED_BY": "258710616||jntf",
            // Client data
            "CUSTOMEREMAIL": foundKeys["email"],
            "CUSTOMERFIRSTNAME": clientType?.clientTypeId === 3 ? foundKeys["name"] : foundKeys["firstName"],
            "CUSTOMERFIRSTSURNAME": foundKeys["firstSurname"],
            "CUSTOMERSECONDSURNAME": foundKeys["secondSurname"],
            "CUSTOMERBIRTHDATE": foundKeys["birthdateText"],
            "CUSTOMEROBS": "",
            "CUSTOMERPHONE": foundKeys["phone1"],
            "CUSTOMERTYPE": clientType?.clientType,
            "SALESMAN": foundKeys["salesman"],
            "ISENICOMPANY": isENICompany,
            // Financial data
            "DIFFERENTIALFEE_NRMONTHS": 0,
            "DIFFERENTIALFEE_VALUE": 0,
            "CAPITALTOFINANCE": foundKeys["capitalToFinance"],
            "EXPENSES": foundKeys["expensesClient"] === "Financiado" ? expensesClient : foundKeys["expensesClient"],
            "EXPENSES_FINANCE": foundKeys["expensesFinance"],
            "FEEWITHOUTINSURENCE": foundKeys["feeWithoutInsurenceClient"],
            "FIRSTPAYMENT": 0,
            "WITH_CAUTION": foundKeys["comcaucao"],
            "GUARANTEE": foundKeys["guarantee"],
            "ID_BUSINESSMANAGER": foundKeys["idBusinessManager"],
            "ID_FINANCIAL": finId,
            "ID_PRODUCT": foundKeys["idProduct"],
            "ID_SUPPLIERENTITY": foundKeys["canvasserIdEntity"],
            "INITIALENTRANCE": foundKeys["initialEntrance"],
            "INSURANCE_PPCNAME": foundKeys["insurancePPCName"],
            "INSURANCE_PPCNRINSUREDPEOPLE": foundKeys["insurancePPCNrInsuredPeople"],
            "INSURANCE_PPCVALUE": 0,
            "ISSPECIALREQUEST": 0,
            "LACKPERIOD": foundKeys["lackPeriod"],
            "MAINTENANCE_CONTRACT": foundKeys["maintenanceContract"],
            "PERIOD": foundKeys["period"],
            "PERIODICITY": foundKeys["periodicity"],
            "PORTSEXPENSES": foundKeys["portsExpenses"],
            "PRICE": foundKeys["price"],
            "PRODUCTNAME": foundKeys["productName"],
            "PURCHASEIVA": foundKeys["purchaseIVA"],
            "RATE": foundKeys["rateClient"],
            "RATETYPE": foundKeys["rateType"],
            "RESIDUALVALUE": foundKeys["residualValue"],
            "REWARD_EXPENSES": 0,
            "REWARD_FINANCIAL": 360,
            "REWARD_FINANCIALDEALER": 360,
            "REWARD_INCREMENTALMONTH1": 0,
            "REWARD_INCREMENTALMONTH2": 0,
            "REWARD_PPCINSURANCE": 0,
            "SALESIVA": foundKeys["salesIVA"],
            "TAEG": foundKeys["taeg"],
            "TAXSTAMP": foundKeys["taxStamp"],
            "TAXSTAMP_FINANCE": foundKeys["taxstampFinance"],
            "WARRANTY_EXTRA": 0,
            "LEGAL_TAX_INVOICED_TO": legalTaxInvoicedTo,
        }

        return new Promise((resolve, reject) => {
            try {
                loadFinancialNationalityMap();

                mapVehicleToSimulationPage(commit, formDataPayload);
                mapClientToSimulationPageFromProposal(commit, formDataPayload);
                mapResultsSimulationPage(commit, formDataPayload);
                mapFinancialToSimulationPage(commit, formDataPayload);
                preSelectEntityOnNavbar(commit, formDataPayload);
                commit("setFromProposal", true);
                commit("setFromProposalData", { proposalId, gscCode });
                commit("SimulationModule/setIdCotation", idCotation, { root: true });

                resolve();
            } catch (error) {
                reject(error);
            }
        });

    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};